var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeletar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4776",
    "data-name": "Grupo 4776",
    transform: "translate(12.017 11.772)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3740",
    "data-name": "Caminho 3740",
    d: "M0,0H40.443V40.443H0Z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3741",
    "data-name": "Caminho 3741",
    d: "M27.359,3H13.084L3,13.084V27.359L13.084,37.443H27.359L37.443,27.359V13.084Zm6.257,22.771-7.845,7.845h-11.1L6.827,25.771v-11.1l7.845-7.845h11.1l7.845,7.845ZM25.637,12.108l-5.415,5.415-5.415-5.415-2.7,2.7,5.415,5.415-5.415,5.415,2.7,2.7,5.415-5.415,5.415,5.415,2.7-2.7L22.92,20.222l5.415-5.415-2.7-2.7Z",
    transform: "translate(0 0)",
    fill: "#ff0027",
    stroke: "#000",
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletar);
export default __webpack_public_path__ + "static/media/deletar.9c6f1d2c434de806333cad7eeb2d70fe.svg";
export { ForwardRef as ReactComponent };